import React from 'react';

import {Section} from "/src/_v2/ui/layout/Section";
import {Container} from "/src/_v2/ui/layout/Container";

import {SectionHeader} from "/src/_v2/ui/patterns/SectionHeader";
import {Text} from "/src/_v2/ui/primitives/Text";
import {EarnTable} from "./EarnTable";

export const EarnSection = ({data, suptitleColor = "green"}) => {

  return (
    <Section>
      <Container className={`tw:space-y-40 tw:md:space-y-64`}>
        <SectionHeader index={data.number} suptitle={data.suptitle} title={data.title} text={data.text}
                       color={suptitleColor}/>

        <div className="tw:flex tw:flex-col tw:md:grid tw:md:grid-cols-12 tw:gap-20 tw:md:gap-24">
          <div className="tw:md:col-span-12 tw:xl:col-span-10 tw:xl:col-start-2 tw:space-y-12 tw:md:space-y-24 tw:xl:space-y-40">
            <EarnTable data={data.table}/>
          </div>
          <div className="tw:md:col-span-6 tw:lg:col-span-5 tw:xl:col-span-5 tw:xl:col-start-2">
            <Text text={data.textLeft}  />
          </div>
          {data.textRight && (
            <div className="tw:md:col-span-6 tw:lg:col-start-7 tw:lg:col-span-5 tw:xl:col-span-4 tw:xl:col-start-8 tw:text-bw-500">
              <Text text={data.textRight} size="sm" className={`tw:!space-y-4`}  />
            </div>
          )}
        </div>

      </Container>
    </Section>
  )
}
